import React from 'react';
// Data
import { smallGalleryImagesArray } from '../../utils/data/GalleryData';

function SmallGalleryComponent() {
  return (
    <section className='grid grid-cols-2 grid-rows-4 h-screen md:max-h-[80vh] lg:max-h-[60vh] md:grid-cols-4 md:grid-rows-2 border-b-2 border-solid border-colour8 md:px-6 lg:px-12 pb-6'>
      {smallGalleryImagesArray.map((image) => (
        <div
          key={image.id}
          className='relative w-full h-full overflow-hidden group'
        >
          <img
            src={image.src}
            alt={image.alt}
            aria-label={image.ariaLabel}
            className='w-full h-full object-cover transition-transform duration-300 group-hover:scale-110'
            loading='lazy'
          />
        </div>
      ))}
    </section>
  );
}

export default SmallGalleryComponent;
